/**
 * Route `name`s used by the route table (`routes.ts`) and `navigateToRoute` /
 * `isSection` call sites.
 *
 * Nested routes use a `parent/child` form (e.g. `admin/users`) so a section
 * stays prefix-matchable (see `AdminPanel.vue`).
 */
export enum RouteName {
  // Top-level workflow routes (navigated to by path via `navigate`/`toggleRoute`).
  Chat = 'chat',
  Operations = 'operations',
  Groups = 'groups',
  Files = 'files',
  Notifications = 'notifications',

  // Settings sub-routes (rendered in the `panel` view under /settings).
  Settings = 'settings',
  SettingsConsent = 'settings/consent',
  SettingsMap = 'settings/map',
  SettingsChangelog = 'settings/changelog',
  SettingsWorkspace = 'settings/workspace',

  // Admin sub-routes (rendered in the `overlay` view under /admin).
  AdminUsers = 'admin/users',
  AdminGroups = 'admin/groups',
  AdminTrackers = 'admin/trackers',
  AdminOperations = 'admin/operations',
  AdminConversations = 'admin/conversations',
  AdminDrawLayers = 'admin/draw-layers',
  AdminConfiguration = 'admin/configuration',
  AdminRoles = 'admin/roles',
  AdminMapSettings = 'admin/map-settings',
  AdminSymbolPacks = 'admin/symbol-packs',
  AdminNexus = 'admin/nexus',
  AdminSystemCheck = 'admin/system-check',
}
